// Centralized Chart.js configuration
// Using chart.js/auto to automatically register ALL components
import 'chart.js/auto';
import { Chart as ChartJS } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

// Register additional plugins
ChartJS.register(ChartDataLabels);

export default ChartJS;
